module.exports = __webpack_public_path__ + "assets/img/sdwan-module8-3.da7341ef.jpg";